import { XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

interface GeotokenSettingsContext {
  settings?: XyoWorldGeotokenSettingsClient | undefined
}

const Context = createContext<GeotokenSettingsContext>({})

export default Context
